export default __webpack_public_path__ + "media/titles/title_3_locale_es-63aa6308.png";